import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

//styles
import '../styles/introStyle.scss';
import '../styles/outro.scss';
import '../styles/transition-group.scss';
import '../styles/transition-fadeUp.scss';

import Iconset from './icons';
import Loaderelement from './loaderelement';

import Shareelement from './shareelement';
import Warenkorb from './warenkorb_menu';


import PreorderBox from './preorder-box';

import ChapterInlineNavi from './chapter_inline_navi';

import Parallax from './parallax';


class Outro extends React.Component{
	constructor(props){
		super(props);
		this.state = {
	    loadStatus : 0,
	    
	  }
	}


	componentDidMount(){
		var parallax = new Parallax(this.refs.parallax);
				parallax.enable();
				if(_assets.isMobile){
					parallax.scalar(6, 0);
				}else{
					parallax.scalar(2, 0);
				}
				parallax.bleed = 5;
	}

  startIntro(){
  	this.props.changeinnerChapter();
  }

  goToHome(){
  	browserHistory.push('/intro');
  }

  render(){
		return (
			<div className="intro-chapter">
			<ReactCSSTransitionGroup
				component= "div"
				className="inner-menu-holder"
			  transitionName="fade"
			  transitionAppear={true}
     		transitionAppearTimeout={500}
			  transitionEnterTimeout={500}
			  transitionLeaveTimeout={300}>
						<main className="main-intro-screen outro">
							<div className="bg-layer overflow-wrapper">
								<div className="bg-layer parallax" ref="parallax">
									<div className="bg-layer layer bg" data-depth="0.00"></div>
									<div className="bg-layer layer one" data-depth="0.50"></div>
									<div className="bg-layer layer two" data-depth="1.00"></div>
								</div>
							</div>
								<div className="logo-icon">
									<button onClick={this.goToHome}><Iconset.logo /></button>
								</div>
								<div className="main-center-screen">
									<header>
										<div className="load-status">
											<h1>A Blossomentary</h1>
											<p>Get more inside information on Milky Chance here! Find out what brought Clemens and Philipp together, how they create music and what’s behind their new album!</p>
											<ChapterInlineNavi inline={true} list={true}/>
										</div>
									</header>
									<PreorderBox />
									<a target="_blank" href="http://eepurl.com/cm56vv" className="newsletter">Get the newsletter</a>
								</div>

								<footer>
									<Warenkorb />
									<Shareelement chapter="home"/>
									
								</footer>
							</main>
					
				</ReactCSSTransitionGroup>
		</div>);
	}
}


export default Outro;


// WEBPACK FOOTER //
// ./src/scripts/outro-screen.js